import { render, staticRenderFns } from "./bankList.vue?vue&type=template&id=2b398e67&"
import script from "./bankList.vue?vue&type=script&lang=ts&"
export * from "./bankList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports